export const initialState = {
    selectedFilters: {},
    filtersVisible: false,
    crLink: '',
};
